// extracted by mini-css-extract-plugin
export default {"overlay":"OhYiJD","overlayVisible":"joIvau"};